<template><div><h1 id="artikelbewegungstypen" tabindex="-1"><a class="header-anchor" href="#artikelbewegungstypen"><span>Artikelbewegungstypen</span></a></h1>
<p>Artikelbewegungstypen — Stammtabelle Artikelbewegungstypen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle ist im System fix definiert und sollte nur durch ARENAE verändert werden. Hier werden die Stammdaten der Artikelbewegungstypen gepflegt. Es ist parametrisierbar, ob manuell Buchungen vorgenommen werden dürfen, oder ob der entsprechende Bewegungstyp nur über Programmfunktionalität (z.B. die Umlagerungsaufträge) gebucht werden kann.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Artikelbewegungs-Typen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Typ</dt>
<dd>
<p>Artikelbewegungstyp</p>
</dd>
<dt>Bezeichnung</dt>
<dd>
<p>Kurzbeschreibung des Artikelbewegungstyps</p>
</dd>
<dt>man. Erfassung?</dt>
<dd>
<p>Manuell erfassbar: ja/nein</p>
</dd>
<dd>
<p>ja = Kann im Fenster &quot;Artikelbewegungen&quot; manuell erfasst, geändert oder gelöscht werden</p>
</dd>
<dd>
<p>nein = Artikelbewegungen dieses Typs werden nur über Systemvorgänge gepflegt und sind nicht manuell änderbar</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.artbeweg.html" title="Artikelbewegungen">Artikelbewegungen</RouteLink></p>
</div></template>


